export default {
    question: 'Delete user&nbsp;<strong>{email}</strong>?',
    notice: 'Attention: This step can <strong>not</strong> be undone!',
    success: 'User&nbsp;<strong>{email}</strong>&nbsp; deleted successfully.',
    action: {
        close: 'Close',
        delete: 'Delete'
    }
}
